<script>
import { reactive, ref, inject } from 'vue'
import { useRouter } from 'vue-router'
import redeMarketingApi from '@/services/api/redeMarketingRepository'

export default {
  setup() {
    const router = useRouter()
    const swal = inject('$swal')
    const salvando = ref(false)

    const form = reactive({
      laravelUserId: null,
      tipoOrigem: 'COACH',
      coachIdLaravel: null,
      nome: '',
      email: '',
      cpf: '',
      telefone: '',
      dataNascimento: null,
      codigoIndicadorPatrocinador: '',
    })

    async function salvar() {
      salvando.value = true
      try {
        const resp = await redeMarketingApi.CriarMembro(form)
        swal({
          icon: 'success',
          title: 'Criado!',
          text: `Membro cadastrado. Código: ${resp.data.codigoIndicacao}`,
        }).then(() => router.push('/rede-marketing/membros'))
      } catch (e) {
        swal({
          icon: 'error',
          title: 'Erro',
          text: e.response?.data?.message || e.message,
        })
      } finally {
        salvando.value = false
      }
    }

    return { form, salvando, salvar }
  },
}
</script>

<template>
  <div>
    <div class="d-flex align-items-center gap-2 mb-3">
      <router-link to="/rede-marketing/membros" class="btn btn-sm btn-light">
        <i class="material-icons align-middle">arrow_back</i>
      </router-link>
      <h3 class="mb-0">Novo Treinador</h3>
    </div>

    <div class="alert alert-info d-flex align-items-start gap-2">
      <i class="material-icons">info</i>
      <div>
        A rede de marketing é <strong>trainer-to-trainer</strong> — apenas treinadores
        podem fazer parte da rede e se indicar entre si. Alunos não são incluídos.
      </div>
    </div>

    <form @submit.prevent="salvar" class="bg-white border rounded p-4">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Laravel User ID *</label>
          <input type="number" class="form-control form-control-sm" v-model.number="form.laravelUserId" required />
          <small class="text-muted">ID do usuário no backend Laravel (já cadastrado como coach).</small>
        </div>
        <div class="col-md-6">
          <label class="form-label">Coach ID (Laravel)</label>
          <input type="number" class="form-control form-control-sm" v-model.number="form.coachIdLaravel" />
          <small class="text-muted">ID na tabela coaches do Laravel.</small>
        </div>

        <div class="col-12">
          <label class="form-label">Nome *</label>
          <input type="text" class="form-control form-control-sm" v-model="form.nome" required maxlength="150" />
        </div>

        <div class="col-md-8">
          <label class="form-label">Email *</label>
          <input type="email" class="form-control form-control-sm" v-model="form.email" required maxlength="150" />
        </div>
        <div class="col-md-4">
          <label class="form-label">CPF</label>
          <input type="text" class="form-control form-control-sm" v-model="form.cpf" maxlength="14" placeholder="000.000.000-00" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Telefone</label>
          <input type="text" class="form-control form-control-sm" v-model="form.telefone" maxlength="20" placeholder="(00) 00000-0000" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Data de Nascimento</label>
          <input type="date" class="form-control form-control-sm" v-model="form.dataNascimento" />
        </div>

        <div class="col-12">
          <label class="form-label">Código do Patrocinador (opcional)</label>
          <input type="text" class="form-control form-control-sm" v-model="form.codigoIndicadorPatrocinador" placeholder="Ex: MBR-XK9TQP" />
          <small class="text-muted">Se preenchido, o membro será vinculado como indicado do patrocinador informado. Caso contrário, vira raiz da árvore.</small>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
        <router-link to="/rede-marketing/membros" class="btn btn-sm btn-light">Cancelar</router-link>
        <button type="submit" class="btn btn-sm btn-success d-flex align-items-center" :disabled="salvando">
          <i class="material-icons me-1" style="font-size: 18px;">save</i>
          {{ salvando ? 'Salvando...' : 'Cadastrar' }}
        </button>
      </div>
    </form>
  </div>
</template>
